import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=2d66a1f7&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=js"
export * from "./Scoreboard.vue?vue&type=script&lang=js"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&id=2d66a1f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d66a1f7",
  null
  
)

export default component.exports